// src/hooks/useScheduledExecutions.ts

//-tech-debt-react-query;
import { useQuery } from '@tanstack/react-query';
import { fetchItems } from '../support/queries';
import { ScheduledTaskExecution } from '../types/taskManager';

interface UseScheduledExecutionsOptions {
  status?: string;
  task_id?: number;
  start_date?: string;
  end_date?: string;
}

export const useScheduledExecutions = (filters?: UseScheduledExecutionsOptions) => {
  // Build query params
  const params = new URLSearchParams();
  if (filters?.status) params.append('status', filters.status);
  if (filters?.task_id) params.append('task_id', String(filters.task_id));
  if (filters?.start_date) params.append('start_date', filters.start_date);
  if (filters?.end_date) params.append('end_date', filters.end_date);

  const endpoint = `queue/scheduled-executions/${params.toString() ? '?' + params.toString() : ''}`;

  const query = useQuery<ScheduledTaskExecution[]>({
    queryKey: ['scheduled-executions', filters],
    queryFn: () => fetchItems(endpoint),
    ...{
        refetchInterval: 30000, // Changed from 15s to 30s
        staleTime: 20000,       // Changed from 5s to 20s
      },
  });

  return {
    executions: query.data || [],
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};

// Execution Details Hook
export const useScheduledExecutionDetails = (executionId: number | null) => {
  const query = useQuery<ScheduledTaskExecution>({
    queryKey: ['scheduled-execution-details', executionId],
    queryFn: () => fetchItems(`queue/scheduled-executions/${executionId}/`),
    ...{
        enabled: !!executionId,
        refetchInterval: 10000,
      },
  });

  return {
    execution: query.data,
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};